const Hassle = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <g clip-path="url(#clip0_8326_2127)">
        <path
          d="M14.5858 8.40122C15.0496 9.98696 14.1586 11.6431 12.5956 12.1003C12.1177 12.2401 11.6322 12.2516 11.1752 12.1548L8.60142 16.1258L7.0723 15.2743L9.64611 11.3034C9.31972 10.9639 9.06758 10.5417 8.92573 10.0568C8.46189 8.47106 9.35293 6.81494 10.9159 6.35776C11.3939 6.21795 11.8793 6.20645 12.3363 6.30322L11.0741 8.64917L12.6032 9.50061L13.8654 7.15467C14.1918 7.49408 14.444 7.91628 14.5858 8.40122Z"
          fill="#1D1D1F"
        />
        <path
          d="M17.5322 5.34519C18.7894 6.88743 19.5433 8.85624 19.5433 11.0011C19.5433 15.9483 15.5328 19.9588 10.5856 19.9588L13.4453 16.977M3.9125 16.977C2.4919 15.3917 1.62793 13.2973 1.62793 11.0011C1.62793 6.05395 5.63842 2.04346 10.5856 2.04346L8.35338 5.13349"
          stroke="#1D1D1F"
          stroke-width="1.62843"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8326_2127">
          <rect
            width="20.3553"
            height="20.3553"
            fill="white"
            transform="translate(0.408691 0.822266)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Hassle
